<template>
    <div class="az-lotes-itens">

        <div v-if="possuiGrupos" class="container-grupos">
            <h3 class="titulo-secao" style="color: #0067A5">Grupos</h3>
            <v-expansion-panel v-model="paineisGrupos" expand class="painel-grupos">
                <v-expansion-panel-content v-for="grupo in grupos" :key="grupo.loteId" class="painel-grupos__linha" style="color: #104D75">
                    <template v-slot:header>
                        <div class="cabecalho-grupo">
                            <strong>{{ grupo.resumoDescricao }}</strong>
                            <span class="info-grupo">
                                ({{ grupo.itens.length }} {{ grupo.itens.length === 1 ? 'item' : 'itens' }})
                            </span>
                        </div>
                    </template>

                    <v-data-table
                        :headers="headersTabelaItensGrupo"
                        :items="grupo.itens"
                        :loading="false"
                        :disable-initial-sort="true"
                        hide-actions
                        class="az-table-list tabela-itens-grupo"
                    >
                        <template slot="items" slot-scope="props">
                            <td>{{ getTipoItemFromItemRow(props.item) }}</td>
                            <td>{{ getSequenciaFromItemRow(props.item) }}</td>
                            <td style="display: flex; align-items: center; gap: 8px;">
                                <v-tooltip top class="tooltip-arredondado">
                                    <template #activator="{ on, attrs }">
                                        <chip-round
                                            v-bind="attrs"
                                            v-on="on"
                                            :label="getTipoMaterialServico(props.item.itemCompra.tipo, 'sigla')"
                                            :tamanho-fonte="'11px'"
                                        />
                                    </template>
                                    <span style="white-space: nowrap;">
                                        {{ getTipoMaterialServico(props.item.itemCompra.tipo, 'text') }}
                                    </span>
                                </v-tooltip>
                                <span class="mr-1">{{ props.item.itemCompra.codigo }} - </span>
                                <texto-ver-mais
                                  :texto="props.item.itemCompra.descricaoCompleta"
                                  :tamanho-maximo="120"
                                  :exibir-mensagem-ver-mais-ver-menos="true"
                                />
                            </td>
                            <td class="no-wrap">{{ props.item.itemCompra.unidade.descricao }}</td>
                            <td style="text-align: right;">
                                <formatador-moeda :valor="props.item.quantidade" :casas-decimais="casasDecimaisQuantidade"></formatador-moeda>
                            </td>
                            <td style="text-align: right;">
                                <formatador-moeda :valor="props.item.valorUnitario" :casas-decimais="licitacao.casasDecimais"></formatador-moeda>
                            </td>
                            <td style="text-align: right;">
                                <formatador-moeda :valor="props.item.valorTotal" :casas-decimais="2"></formatador-moeda>
                            </td>
                        </template>
                    </v-data-table>

                    <div class="total-grupo" v-if="!isFornecedor && (isMenorPreco || isMaiorOferta || isTecnicaPreco)">
                        <div class="resume">
                            <label>Total do Grupo: </label>
                            <span>R$ <formatador-moeda :valor="grupo.totalGrupo" :casas-decimais="2"></formatador-moeda></span>
                        </div>
                    </div>
                </v-expansion-panel-content>
            </v-expansion-panel>
        </div>
      
        <div v-if="possuiItensIndividuais" class="container-itens-individuais">
            <h3 class="titulo-secao" :class="{ 'mt-4': possuiGrupos }" style="color: #0067A5">Itens</h3>
            <v-flex xs12 sm12 d-flex>
                <v-form @submit.prevent="atualizarLotesItens">
                    <v-data-table
                            :headers="headersTabelaItens"
                            :items="itensIndividuais"
                            :loading="false"
                            :disable-initial-sort="true"
                            hide-actions
                            class="az-table-list tabela-itens-individuais"
                    >
                        <template slot="items" slot-scope="props">
                          <td>{{ getTipoItemFromItemRow(props.item) }}</td>
                          <td>{{ getSequenciaFromItemRow(props.item) }}</td>
                          <td style="display: flex; align-items: center; gap: 8px;">
                          <v-tooltip top class="tooltip-arredondado">
                              <template #activator="{ on, attrs }">
                                <chip-round
                                    v-bind="attrs"
                                    v-on="on"
                                    :label="getTipoMaterialServico(props.item.itemCompra.tipo, 'sigla')"
                                    :tamanho-fonte="'11px'"
                                />
                              </template>
                              <span style="white-space: nowrap;">
                                {{ getTipoMaterialServico(props.item.itemCompra.tipo, 'text') }}
                              </span>
                            </v-tooltip>

                            <span class="mr-1">{{ props.item.itemCompra.codigo }} - </span>
                            <texto-ver-mais
                              :texto="props.item.itemCompra.descricaoCompleta"
                              :tamanho-maximo="120"
                              :exibir-mensagem-ver-mais-ver-menos="true"
                            />
                          </td>
                          <td class="no-wrap">{{ props.item.itemCompra.unidade.descricao }}</td>
                          <td style="text-align: right;">
                            <formatador-moeda :valor="props.item.quantidade" :casas-decimais="casasDecimaisQuantidade"></formatador-moeda>
                          </td>

                          <td style="text-align: right;">
                            <formatador-moeda :valor="props.item.valorUnitario" :casas-decimais="licitacao.casasDecimais"></formatador-moeda>
                          </td>

                          <td style="text-align: right;">
                            <formatador-moeda :valor="props.item.valorTotal" :casas-decimais="2"></formatador-moeda>
                          </td>
                        </template>
                    </v-data-table>
                </v-form>
            </v-flex>
            <div class="resume-itens" v-if="possuiItensIndividuais && !isFornecedor && (isMenorPreco || isMaiorOferta || isTecnicaPreco)">
                <div class="resume">
                    <label>Total Itens Individuais: </label>
                    <span>R$ <formatador-moeda :valor="totalItensIndividuais" :casas-decimais="2"></formatador-moeda></span>
                </div>
            </div>
        </div>

        <div class="resume-itens" v-if="possuiLotes && !isFornecedor && (isMenorPreco || isMaiorOferta || isTecnicaPreco)">
            <div class="resume">
                <label>Total Unitário: </label>
                <span>R$ <formatador-moeda :valor="totalUnitario" :casas-decimais="licitacao.casasDecimais"></formatador-moeda></span>
                <span class="separator">|</span>
                <label>Total Geral: </label>
                <span>R$ <formatador-moeda :valor="totalGeral" :casas-decimais="2"></formatador-moeda></span>
            </div>
        </div>
        <div class="resume-itens" v-if="possuiLotes && !isFornecedor && !isMenorPreco && !isMaiorOferta && !isTecnicaPreco">
            <div class="resume">
                <label>Média </label>
                <span>(%) <formatador-moeda :valor="mediaDesconto" :casas-decimais="licitacao.casasDecimais"></formatador-moeda></span>
            </div>
        </div>
        
        <div class="az-actions-form">
            <div class="align-left"></div>
            <div class="align-right" v-if="possuiLotes && editando && isEditavel">
                <a class="action-primary" @click="atualizarLotesItens">Salvar</a>
            </div>
        </div>
        <az-ops title="Ops! Nenhum lote encontrado."
                message="Adicione lotes através do botão importar com a tela no modo de edição."
                v-if="!possuiLotes && !editando"
        ></az-ops>
        <az-confirm @onConfirm="chamarEventoRemoverLotes(); mostrarDialogRemoverLotes = false;"
                    @onDecline="mostrarDialogRemoverLotes = false"
                    v-if="mostrarDialogRemoverLotes">
            Todos os lotes serão removidos! Tem certeza que deseja reimportar os lotes?
        </az-confirm>
    </div>
</template>

<script>
    import {mapState} from 'vuex'
    import FormatadorMoeda from '@/commons/components/FormatadorMoeda.vue'
    import {actionTypes, tiposLicitacao} from '@/commons/constants'
    import AzComboEnumLicitacao from "@/commons/components/AzComboEnumLicitacao.vue";
    import EdlFileUpload from "@/commons/components/file/EdlFileUpload.vue";
    import tipoMaterialServico from "@/commons/constants/tipo-item-material-servico";
    import ChipRound from "@/views/credenciamento/detalhe-credenciamento/commons/ChipRound.vue";
    import TextoVerMais from "@/views/credenciamento/detalhe-credenciamento/commons/TextoVerMais.vue";
    import {normalizarCasasDecimais} from "@/commons/utils/CasasDecimaisUtils";
 
     export default {
        name: 'LotesItens',
        inject: ['$validator'],
        props: {
            possuiProposta: {
              default: false
            },
            editando: {
                default: false
            },
            publicado:{
                default: false
            }
        },
        components: {ChipRound, EdlFileUpload, AzComboEnumLicitacao, FormatadorMoeda, TextoVerMais },
        data() {
            return {
                repository: 'repo1:licitacao',
                mostrarDialogRemoverLotes: false,
                tiposImportacao: ['Planilha'],
                tipoImportacao: 'Planilha',
                modelosExportacao: [],
                modeloExportacao: null,
                tiposIncluirFichaCatalogo: [
                    {value: null, text: 'Selecione'},
                    {value: true, text: 'Sim'},
                    {value: false, text: 'Não'}
                ],
                orgaoLogado: null,
                paineisGrupos: []
            }
        },
        computed: {
            ehPerfilSiga(){
              return !this.$store.state.parametros.propriedadesLicitacao.ehPerfilComprasBR
            },
            isEditavel(){
              return this.licitacao.status === "AGUARDANDO_ABERTURA" &&
                  (this.licitacao.amparoLegal && !this.licitacao.amparoLegal.pncp) ||
                  !this.licitacao.publicado
            },
            possuiLotes() {
                return this.lotesLicitacao.length > 0
            },
            casasDecimaisQuantidade() {
                return normalizarCasasDecimais(this.licitacao.casasDecimaisQuantidade)
            },
            grupos() {
                const gruposMap = new Map()
                
                this.lotesLicitacao.forEach(item => {
                    const resumoDescricao = item.licitacaoLote.lote.resumoDescricao

                    if (resumoDescricao && (resumoDescricao.toLowerCase().includes('lote') || resumoDescricao.toLowerCase().includes('grupo'))) {
                        const loteId = item.licitacaoLote.lote.id
                        
                        if (!gruposMap.has(loteId)) {
                            gruposMap.set(loteId, {
                                loteId: loteId,
                                resumoDescricao: resumoDescricao,
                                itens: [],
                                totalGrupo: 0
                            })
                        }
                        
                        const grupo = gruposMap.get(loteId)
                        grupo.itens.push(item)
                        grupo.totalGrupo += item.valorTotal || 0
                    }
                })
                
                return Array.from(gruposMap.values())
            },
            itensIndividuais() {
                return this.lotesLicitacao.filter(item => {
                    const resumoDescricao = item.licitacaoLote.lote.resumoDescricao
                    return !resumoDescricao || (!resumoDescricao.toLowerCase().includes('lote') && !resumoDescricao.toLowerCase().includes('grupo'))
                })
            },
            possuiGrupos() {
                return this.grupos.length > 0
            },
            possuiItensIndividuais() {
                return this.itensIndividuais.length > 0
            },
            totalGeral() {
                let totalGeral = 0;
                this.lotesLicitacao.forEach(lote => {
                    totalGeral = totalGeral + lote.valorTotal
                })
                return totalGeral
            },
            totalUnitario() {
                let totalUnitario = 0;
                this.lotesLicitacao.forEach(lote => {
                    totalUnitario = totalUnitario + lote.valorUnitario
                })
                return totalUnitario
            },
            totalItensIndividuais() {
                let total = 0;
                this.itensIndividuais.forEach(item => {
                    total += item.valorTotal || 0
                })
                return total
            },
            mediaDesconto() {
                let somatoriaMedia = 0;
                this.lotesLicitacao.forEach(lote => {
                    somatoriaMedia += lote.valorUnitario
                })
                return somatoriaMedia / this.lotesLicitacao.length
            },
            isMenorPreco() {
                return tiposLicitacao[this.licitacao.tipoLicitacao] === tiposLicitacao.MP
            },
            isMaiorDesconto() {
              return tiposLicitacao[this.licitacao.tipoLicitacao] === tiposLicitacao.MD
            },
            isMaiorOferta() {
              return tiposLicitacao[this.licitacao.tipoLicitacao] === tiposLicitacao.MO
            },
            isTecnicaPreco() {
              return tiposLicitacao[this.licitacao.tipoLicitacao] === tiposLicitacao.TP
            },
            headersTabelaItensGrupo(){
                return [
                    {
                        text: 'Tipo',
                        align: 'left',
                        sortable: false,
                        value: 'tipoItem',
                        width: '100px',
                        class: 'primary--text'
                    },
                    {
                      text: 'Seq.',
                      align: 'left',
                      sortable: false,
                      value: 'sequencia',
                      width: '80px',
                      class: 'primary--text'
                    },
                    {
                        text: 'Código/Descrição',
                        value: 'descricao',
                        sortable: false,
                        align: 'left',
                        class: 'primary--text'
                    },
                    {
                        text: 'Un. Aquisição',
                        value: 'unidade',
                        sortable: false,
                        align: 'center',
                        class: 'primary--text'
                    },
                    {
                        text: 'Quantidade',
                        value: 'quantidade',
                        sortable: false,
                        align: 'center',
                        width: '100px',
                        class: 'primary--text'
                    },
                    {
                        text: 'Vlr. Unitário',
                        value: 'valorUnitario',
                        sortable: false,
                        align: 'right',
                        width: '100px',
                        class: 'primary--text'
                    },
                    {
                        text: 'Vlr. Total',
                        value: 'valorTotal',
                        sortable: false,
                        align: 'center',
                        width: '100px',
                        class: 'primary--text'
                    }
                ]
            },
            headersTabelaItens(){
                return [
                  {
                    text: 'Tipo',
                    align: 'left',
                    sortable: false,
                    value: 'tipoItem',
                    width: '100px',
                    class: 'primary--text'
                  },
                  {
                    text: 'Seq.',
                    align: 'left',
                    sortable: false,
                    value: 'sequencia',
                    width: '80px',
                    class: 'primary--text'
                  },
                  {
                    text: 'Código/Descrição',
                    value: 'descricao',
                    sortable: false,
                    align: 'left',
                    class: 'primary--text'
                  },
                  {
                    text: 'Un. Aquisição',
                    value: 'unidade',
                    sortable: false,
                    align: 'center',
                    class: 'primary--text'
                  },
                  {
                    text: 'Quantidade',
                    value: 'quantidade',
                    sortable: false,
                    align: 'center',
                    width: '100px',
                    class: 'primary--text'
                  },
                  {
                    text: 'Unitário(R$)',
                    value: 'valorUnitario',
                    sortable: false,
                    align: 'right',
                    width: '100px',
                    class: 'primary--text'
                  },
                  {
                    text: 'Total(R$)',
                    value: 'valorTotal',
                    sortable: false,
                    align: 'center',
                    width: '100px',
                    class: 'primary--text'
                  }
                ]
            },
            ...mapState(['loki', 'lotesLicitacao', 'licitacao'])
        },
        watch: {
            'loki.uploadedFiles': {
                async handler(newVal) {
                    if (this.tipoImportacao === 'Planilha') {
                        this.$emit('onUploadCompletoPlanilhaLotes', newVal)
                    } else {
                        this.$emit('onUploadCompletoTextoLotes', newVal, this.tipoImportacao)
                    }
                }
            },
            grupos: {
                handler() {
                    this.paineisGrupos = this.grupos.map(() => true)
                },
                immediate: true
            }
        },
        methods: {
            async buscarOrgaoLogado() {
              if(this.$store.state.loki.user.type === 'EXTERNO'){return}
              const uo = await this.$store.dispatch(actionTypes.BUSCAR_ORGAO, {orgaoId:this.$store.state.loki.user.domainId});
              if(!uo) {return}
              const orgaos = this.$store.state.orgaos
              this.orgaoLogado = orgaos.find(orgao => orgao.id === uo.unidadeOrganizacional.id)
            },
            getNomeLote() {
              if(this.licitacao.ehPerfilComprasBR) {
                return 'Lote'
              }
              return 'Tipo'
            },
            chamarEventoRemoverLotes() {
                this.$emit('onConfirmarRemoverLotes')
            },
            async buscarNomesModelosImportacao() {
                return await this.$store.dispatch(actionTypes.BUSCAR_NOMES_MODELOS_IMPORTACAO)
            },
            async buscarNomesModelosExportacao() {
                return await this.$store.dispatch(actionTypes.BUSCAR_NOMES_MODELOS_EXPORTACAO)
            },
            async atualizarLotesItens() {
                try {
                    const validado = await this.$validator._base.validateAll()
                    if (!validado) {
                        this.mostrarNotificacaoErro('Existem lotes com campos obrigatórios não preenchidos.')
                        return
                    }
                    this.habilitarLoadingGlobal()
                    this.setMensagemLoading('Atualizando os lotes...')
                    await this.$store.dispatch(actionTypes.ATUALIZAR_LOTES_ITENS, {
                        licitacaoId: this.licitacao.id,
                        lotesItens: this.lotesLicitacao
                    })
                    this.mostrarNotificacaoSucessoDefault()
                    this.desabilitarLoadingGlobal()
                } catch (e) {
                    this.desabilitarLoadingGlobal()
                }
            },
            mudarTipoNegociacaoItensMesmoLote(loteId, tipoNegociacao) {
                this.lotesLicitacao.forEach(itemLote => {
                    if (itemLote.licitacaoLote.lote.id === loteId) {
                        itemLote.licitacaoLote.tipoNegociacao = tipoNegociacao
                    }
                })
            },
            mudarFichaCatalogoItensMesmoLote(loteId, valor, campo) {
                this.lotesLicitacao.forEach(itemLote => {
                    if (itemLote.licitacaoLote.lote.id === loteId) {
                        itemLote.licitacaoLote[campo] = valor
                    }
                })
            },
            decodificarBase64(strBase64) {
                return window.decodeURIComponent(window.atob(strBase64).split('').map(function (c) {
                    return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
                }).join(''))
            },
            decodificarBytesString(str) {
                const stringDecodificadaUtf8 = this.decodificarBase64(str)
                const binaryLen = stringDecodificadaUtf8.length
                const bytes = new Uint8Array(binaryLen)
                for (let i = 0; i < binaryLen; i++) {
                    bytes[i] = stringDecodificadaUtf8.charCodeAt(i)
                }

                return [bytes]
            },
            async exportarIpm(){
              try {
                this.habilitarLoadingGlobal()
                this.setMensagemLoading('Exportando lotes...')
                await this.$store.dispatch(actionTypes.EXPORTAR_RESULTADO_IPM, this.licitacao.id)
                this.mostrarNotificacaoSucessoDefault()
                this.desabilitarLoadingGlobal()
              } catch (err) {
                this.desabilitarLoadingGlobal()
              }
            },
            async exportarSgc(){
              try {
                this.habilitarLoadingGlobal()
                this.setMensagemLoading('Exportando lotes...')
                await this.$store.dispatch(actionTypes.EXPORTAR_LOTES_ITENS_SGC, {
                  licitacaoId: this.licitacao.id,
                  nomeModelo: this.modeloExportacao
                })
                this.mostrarNotificacaoSucessoDefault()
                this.desabilitarLoadingGlobal()
              } catch (err) {
                this.desabilitarLoadingGlobal()
              }
            },
            getTipoMaterialServico(sigla, chave) {
              const mod = (tipoMaterialServico && typeof tipoMaterialServico === 'object') ? tipoMaterialServico : (require('@/commons/constants/tipo-item-material-servico').default || {});
              const lista = Object.values(mod);
              const norm = v => (v || '').toString().trim().toUpperCase();
              const t = norm(sigla);
              let item = lista.find(el => norm(el.sigla) === t || norm(el.value) === t || norm(el.text) === t);
              if (!item) {
                if (t.startsWith('M')) item = lista.find(el => norm(el.value) === 'MATERIAL');
                if (!item && (t.startsWith('S') || t.startsWith('SERV'))) item = lista.find(el => norm(el.value) === 'SERVICO');
              }
              return item ? item[chave] : null;
            },
            // ===== Helpers para Tipo/Sequência (igual regra das outras telas)
            containsIgnoreCase(src, needle) {
              if (!src || !needle) return false;
              try { return new RegExp(needle.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'i').test(src); } catch (e) { return false; }
            },
            isGrupoDesc(desc) { return this.containsIgnoreCase(desc, 'grupo'); },
            isItemDesc(desc) { return this.containsIgnoreCase(desc, 'item'); },
            extractNumberFromDesc(desc, keyword) {
              if (!desc) return null;
              const cleaned = desc.replace(new RegExp(keyword, 'ig'), '').trim()
                                  .replace(/[^0-9.]+/g, '')
                                  .replace(/^\.+|\.+$/g, '');
              return cleaned && cleaned.length ? cleaned : null;
            },
            getLoteDesc(row) {
              try {
                const lote = row && row.licitacaoLote && row.licitacaoLote.lote ? row.licitacaoLote.lote : null;
                if (!lote) return null;
                return lote.descricao || lote.resumoDescricao || null;
              } catch (e) { return null; }
            },
            getTipoItemFromItemRow(row) {
              const desc = this.getLoteDesc(row);
              if (this.isGrupoDesc(desc)) return desc;
              if (this.isItemDesc(desc)) return 'Item';
              return 'Item';
            },
            getSequenciaFromItemRow(row) {
              const desc = this.getLoteDesc(row);
              if (this.isGrupoDesc(desc)) {
                return row && row.numSequencia != null ? row.numSequencia : null;
              }
              if (this.isItemDesc(desc)) {
                return this.extractNumberFromDesc(desc, 'item');
              }
              return row && row.numSequencia != null ? row.numSequencia : null;
            },
            async exportar() {
                try {
                    const validado = await this.$validator._base.validateAll()
                    if (!validado) {
                        return
                    }
                    this.habilitarLoadingGlobal()
                    this.setMensagemLoading('Exportando lotes...')
                    await this.$store.dispatch(actionTypes.EXPORTAR_LOTES_ITENS, {
                        licitacaoId: this.licitacao.id,
                        nomeModelo: this.modeloExportacao
                    })
                    this.mostrarNotificacaoSucessoDefault()
                    this.desabilitarLoadingGlobal()
                } catch (err) {
                    this.desabilitarLoadingGlobal()
                }
            },
        },
        async mounted() {
            const nomesModelosImportacao = await this.buscarNomesModelosImportacao()
            const nomesModelosExportacao = await this.buscarNomesModelosExportacao()
            this.tiposImportacao = this.tiposImportacao.concat(nomesModelosImportacao)
            nomesModelosExportacao.forEach((value)=>{
              let obj = {text: value === "Sistema E L" ? "Sistema E&L" : value, value:value}
              this.modelosExportacao.push(obj)
            })
            await this.buscarOrgaoLogado()
        }
    }
</script>

<style scoped>
.az-lotes-itens .titulo-secao {
    font-size: 18px;
    font-weight: bold;
    color: #3a6861;
    margin-bottom: 15px;
}

.az-lotes-itens .container-grupos, 
.az-lotes-itens .container-itens-individuais {
    margin-bottom: 20px;
}

.az-lotes-itens .painel-grupos .painel-grupos__linha {
    border: 1px solid #e0e0e0;
    border-radius: 4px;
    margin-bottom: 10px;
}

.az-lotes-itens .painel-grupos .cabecalho-grupo {
    display: flex;
    align-items: center;
    gap: 10px;
}

.az-lotes-itens .painel-grupos .info-grupo {
    color: #666;
    font-size: 12px;
    font-weight: normal;
}

.az-lotes-itens .total-grupo {
    text-align: right;
    padding: 10px 0;
    border-top: 1px solid #f0f0f0;
    margin-top: 10px;
}

.az-lotes-itens .total-grupo .resume label {
    font-weight: bold;
    font-size: 13px;
    color: #777777;
}

.az-lotes-itens .total-grupo .resume span {
    font-weight: normal;
    font-size: 13px;
    color: #777777;
}

.az-lotes-itens .resume-itens {
    display: block;
    margin-bottom: 20px;
    margin-top: 10px;
    text-align: end;
    width: 100%;
}

.az-lotes-itens .resume-itens .resume .separator {
    margin: 0 15px;
}

.az-lotes-itens .resume-itens .resume label {
    font-weight: bold;
    font-size: 13px;
    color: #777777;
}

.az-lotes-itens .resume-itens .resume span {
    font-weight: normal;
    font-size: 13px;
    color: #777777;
}

.container-tabela-itens, 
.container-grupos, 
.container-itens-individuais {
    margin-top: 15px;
    overflow: auto;
}

.tabela-lotes-itens, 
.tabela-itens-grupo, 
.tabela-itens-individuais {
    padding: 0px;
}

.tabela-lotes-itens td, 
.tabela-itens-grupo td, 
.tabela-itens-individuais td {
    padding: 12px 16px !important;
    vertical-align: middle;
}

.no-wrap {
    white-space: nowrap;
}

@media (max-width: 720px) {
    .resume {
        display: block;
    }
    
    .resume .separator {
        display: block;
        visibility: hidden;
        height: 0;
    }

    .tabela-lotes-itens td:nth-of-type(1):before,
    .tabela-itens-individuais td:nth-of-type(1):before {
        content: "Seq:";
    }

    .tabela-lotes-itens td:nth-of-type(2):before,
    .tabela-itens-individuais td:nth-of-type(2):before {
        content: "Descrição Seq:";
    }

    .tabela-lotes-itens td:nth-of-type(3):before,
    .tabela-itens-individuais td:nth-of-type(3):before {
        content: "Descrição:";
    }

    .tabela-lotes-itens td:nth-of-type(4):before,
    .tabela-itens-individuais td:nth-of-type(4):before {
        content: "Unidade:";
    }

    .tabela-lotes-itens td:nth-of-type(5):before,
    .tabela-itens-individuais td:nth-of-type(5):before {
        content: "Quantidade:";
    }

    .tabela-lotes-itens td:nth-of-type(6):before,
    .tabela-itens-individuais td:nth-of-type(6):before {
        content: "Unitário(R$):";
    }

    .tabela-lotes-itens td:nth-of-type(7):before,
    .tabela-itens-individuais td:nth-of-type(7):before {
        content: "Total(R$):";
    }

    .tabela-itens-grupo td:nth-of-type(1):before {
        content: "Seq:";
    }

    .tabela-itens-grupo td:nth-of-type(2):before {
        content: "Descrição:";
    }

    .tabela-itens-grupo td:nth-of-type(3):before {
        content: "Unidade:";
    }

    .tabela-itens-grupo td:nth-of-type(4):before {
        content: "Quantidade:";
    }

    .tabela-itens-grupo td:nth-of-type(5):before {
        content: "Unitário(R$):";
    }

    .tabela-itens-grupo td:nth-of-type(6):before {
        content: "Total(R$):";
    }
}
</style>